import { AppUsers } from "./AppUsers";
import { DataSafe } from "@/models/DataSafe"


interface StringKeyArray {
    [index: string]: number;
}

export class SexAndLibido{
    static attributePrefix = "Sex and libido";
    static attributePrefixDe = "Sex und Libido";}